(function(app) {

    app.directive("split",
    [
        function() {
            return {
                scope: true,
                require: ["ngModel"],
                controller: [
                    "$scope", function($scope) {
                        var renderers = [];
                        var values = [];
                        this.register = function(fn) {
                            renderers.push(fn);
                        };
                        this.update = function(index, val) {
                            values[index] = val;
                        };
                        this.buildView = function() {
                            var view = "";
                            for (var i = 0; i < values.length; i++)
                                if (values[i])
                                    view += values[i];
                            if ($scope.$$phase)
                                $scope.setViewValue(view);
                            else
                                $scope.$apply(function() {
                                    $scope.setViewValue(view);
                                });
                        };
                        $scope.render = function() {
                            for (var i = 0; i < renderers.length; i++)
                                renderers[i]();
                        };
                    }
                ],
                link: function(scope, elem, attrs, ctrls) {
                    var ngModel = ctrls[0];
                    ngModel.$render = function() {
                        scope.render();
                    };
                    scope.setViewValue = function(val) {
                        ngModel.$setViewValue(val);
                    };
                }
            };
        }
    ]);

    app.directive("splitSection",
    [
        "$parse", "$sniffer", "$browser", "$timeout", function($parse, $sniffer, $browser, $timeout) {
            return {
                scope: true,
                require: ["^split", "^ngModel"],
                link: function(scope, elem, attrs, ctrls) {
                    var parent = ctrls[0];
                    var ngModel = ctrls[1];
                    var params = $parse(attrs.splitSection)();
                    parent.register(render);
                    $timeout(function() {
                        parent.update(params[0], (ngModel.$viewValue || "").substring(params[0], params[1]));
                    });

                    function render() {
                        parent.update(params[0], (ngModel.$viewValue || "").substring(params[0], params[1]));
                        elem.val((ngModel.$viewValue || "").substring(params[0], params[1]));
                    }

                    function listener() { //remove ev because it was not being used
                        var val = elem.val() || "";
                        if (val.length >= params[1] - params[0]) {
                            elem.val(val = val.substring(0, params[1] - params[0]));
                            elem.next("input").focus();
                        }
                        parent.update(params[0], val);
                        parent.buildView();
                    };

                    //from angular's input[text] directive: https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L881
                    if ($sniffer.hasEvent("input")) {
                        elem.on("input", listener);
                    } else {
                        var timeout;
                        var deferListener = function(ev) {
                            if (!timeout) {
                                timeout = $browser.defer(function() {
                                    listener(ev);
                                    timeout = null;
                                });
                            }
                        };
                        elem.on("keydown",
                            function(event) {
                                var key = event.keyCode;
                                // ignore
                                //    command            modifiers                   arrows
                                if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
                                deferListener(event);
                            });
                        // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
                        if ($sniffer.hasEvent("paste")) {
                            elem.on("paste cut", deferListener);
                        }
                    }

                    // if user paste into input using mouse on older browser
                    // or form autocomplete on newer browser, we need "change" event to catch it
                    elem.on("change", listener);
                }
            };
        }
    ]);

})(window.app); //jshint ignore:line